<template>
    <b-overlay :show="formIsLoading" rounded="sm">
        <b-card class="shadowed">
            <p class="text-overline text-secondary mb-0">{{`${trans('webinars.registration.date')}:
                ${webinarDetails.date_time}`}}</p>
            <h4 class="text-primary">{{webinarDetails.title}}</h4>
            <b-alert variant="danger" v-model="showErrors" class="text-center">{{errors[0]}}</b-alert>
            <b-form @submit.stop.prevent="submitForm">
                <b-form-group
                    id="form-shortcut"
                    :label="`${fork.questionText}*`"
                    label-for="user-fork"
                    label-class="h6"
                    label-cols="12"
                    v-if="fork"
                >
                    <b-form-radio
                        v-for="answer in fork.answers"
                        v-bind:key="answer.relatedModuleId"
                        v-bind:value="answer.relatedModuleId"
                        v-model="formData.selected"
                        button
                        name="radios-btn-default"
                        class="mb-3 w-100"
                        button-variant="outline-secondary btn-block"
                        required
                    >
                        {{answer.answerText}}
                    </b-form-radio>
                </b-form-group>

                <div v-for="field in Object.values(formFields)" :key="field.id">
                    <b-form-group
                            :id="field.id.toString()"
                            :label="`${field.field_caption}${field.required === 1 ? '*' : ''}`"
                            :label-for="field.field_id.toString()"
                            label-class="h6"
                            v-if="field.field_type === 'textbox'"
                    >
                        <b-form-input
                                :id="field.field_id.toString()"
                                v-model="formData[field.field_id]"
                                trim
                                :required="field.required === 1"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                            :id="field.id.toString()"
                            :label="`${field.field_caption}${field.required === 1 ? '*' : ''}`"
                            :label-for="field.field_id.toString()"
                            label-class="h6"
                            v-if="field.field_type === 'multicheck'"
                            :invalid-feedback="invalidFeedback(field.field_id)"
                            :state="state(field.field_id)"
                    >
                        <b-form-checkbox-group
                                :id="field.field_id.toString()"
                                v-model="formData[field.field_id]"
                                :options="field.options"
                                stacked
                                @input="onMulticheckChange(field.field_id)"
                        ></b-form-checkbox-group>
                    </b-form-group>

                    <b-form-group
                            :id="field.id.toString()"
                            :label="`${field.field_caption}${field.required === 1 ? '*' : ''}`"
                            :label-for="field.field_id.toString()"
                            label-class="h6"
                            v-if="field.field_type === 'option'"
                    >
                        <b-form-radio-group
                                :id="field.field_id.toString()"
                                v-model="formData[field.field_id]"
                                :options="field.options"
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group
                            :id="field.id.toString()"
                            label-class="h6"
                            v-if="field.field_type === 'checkbox'"
                    >
                        <b-form-checkbox
                                :id="field.field_id"
                                v-model="formData[field.field_id]"
                                :name="field.field_caption"
                                value="Y"
                                unchecked-value="N"
                                :required="field.required === 1"
                        >
                            {{`${field.field_caption}`}}
                            <a v-if="field.hasOwnProperty('isPrivacy')" class="text-secondary" rel="noopener noreferrer"
                               target="_blank" href="https://www.on24.com/privacy-policy/">privacy policy</a>
                            {{`${field.required === 1 ? '*' : ''}`}}
                        </b-form-checkbox>
                    </b-form-group>
                </div>

                <div class="d-flex justify-content-end">
                    <b-button type="submit" variant="secondary" :disabled="isLoading">{{trans('webinars.registration.confirm')}}</b-button>
                </div>
            </b-form>
        </b-card>
    </b-overlay>
</template>

<script>
    export default {
        name: "WebinarRegistrationForm",
        props: {
            sessionId: String
        },
        data() {
            return {
                webinarDetails: {},
                formFields: {},
                formData: {},
                isLoading: false,
                errors: [],
                formValid: false,
                excludedFields: ['email', 'company', 'firstname', 'lastname'],
                formIsLoading: true,
                fork:null
            }
        },
        computed:{
            showErrors(){
                return this.errors.length > 0;
            },

        },
        methods: {
            submitForm() {
                this.isLoading = true;
                this.errors = [];
                this.formValid = true;
                let data = {...this.formData};

                Object.keys(data).map(key => {
                    if (Array.isArray(data[key])) {
                        if(data[key].length === 0){
                            this.formFields[key].blur = true;
                            this.formValid = false;
                            this.isLoading = false;
                        }else{
                            data[key] = data[key].join('|');
                        }
                    }
                });

                if(this.formValid === true){
                    this.$axios.post(`/api/rest/webinar/${this.sessionId}/signup`, data)
                        .then(res => {
                            this.isLoading = false;
                            this.$emit('registrationComplete');
                            trackEvent('WebinarConfirmClick', {})
                        })
                        .catch(err => {
                            console.log(err.response);
                            this.isLoading = false;
                        })
                }
            },
            getWebinarDetails() {
                this.formIsLoading = true;
                this.$axios.get(`/api/rest/webinar/${this.sessionId}/details`)
                    .then(res => {
                        this.formIsLoading = false;
                        this.webinarDetails = res.data.details;
                        const filteredFields = res.data.questions.filter(field => !this.excludedFields.includes(field.field_id));
                        filteredFields.map(field => {
                            this.formFields[field.field_id] = field;
                        })
                        filteredFields.map((field) => {
                            switch(field.field_type){
                                case 'multicheck':
                                    let checkboxOptions = [];
                                    field.options.map(checkbox => {
                                        checkboxOptions.push({
                                            text: checkbox,
                                            value: checkbox
                                        })
                                    })
                                    this.formFields[field.field_id].options = checkboxOptions;
                                    this.formFields[field.field_id]['isMultiCheck'] = true;
                                    this.formFields[field.field_id]['isValid'] = false;
                                    this.formFields[field.field_id]['blur'] = false;
                                    this.formData[field.field_id] = [];
                                    break;
                                case 'checkbox':
                                    if(field.field_caption.includes("privacy policy")){
                                        this.formFields[field.field_id]['field_caption'] = field.field_caption.replace('privacy policy', '');
                                        this.formFields[field.field_id]['isPrivacy'] = true;
                                    }
                                    break;
                                case 'option':
                                    let radioOptions = [];
                                    field.options.map(radio => {
                                        radioOptions.push({
                                            text: radio,
                                            value: radio
                                        })
                                    })
                                    this.formFields[field.field_id].options = radioOptions;
                                    this.formData[field.field_id] = [];
                                    break;
                                default:
                                    this.formData[field.field_id] = '';
                                    break;
                            }
                        })
                        if(res.data.fork.hasFork){
                            this.fork = res.data.fork;
                            this.formData = {...this.formData, selected: ''}
                        }
                        trackEvent("WebinarRegistrationForm", {sessionId: this.sessionId, webinarId: this.webinarDetails.webinar_id});
                    })
                    .catch(err => {
                        this.formIsLoading = false;
                        console.log(err);
                    });
            },
            state(fieldId) {
                return !this.formFields[fieldId]['isValid'] && this.formFields[fieldId]['blur'] ? false : null;
            },
            invalidFeedback(fieldId) {
                if (this.formData[fieldId].length > 0) {
                    return '';
                } else {
                    return this.trans('webinars.registration.select_one');
                }
            },
            onMulticheckChange(fieldId){
                this.formFields[fieldId]['blur'] = true;
                this.formFields[fieldId]['isValid'] = this.formData[fieldId].length > 0;
                this.$forceUpdate();
            }
        },
        mounted() {
            this.getWebinarDetails();
        }
    }
</script>